import { runInAction } from 'mobx';
import { temporaryOrderDomainStore } from '../../temporary-store/store';
import { createDefaultInProgressItem } from '../../utils/items/create-default-in-progress-item';
export const createInProgressItem = (sellableItem) => {
    const inProgressItem = createDefaultInProgressItem(sellableItem);
    runInAction(() => {
        temporaryOrderDomainStore.data.inProgressItems.push(inProgressItem);
    });
};
